import { useState } from 'react';
import { applyNow, dismissUpdate, useUpdateStatus } from '../lib/liveUpdate';

/**
 * 「有新版本」的提示条。
 *
 * 后台每次检查(启动、回到前台、开着时每半小时)发现新版本,下载好之后弹出来。
 *
 * ★ 提示条,不是弹窗。司机可能正在拍签收照、填代收金额 ——
 *   弹窗挡在他手上的活前面,逼他先做选择;提示条可以先不理。
 * ★ 浮在顶上,不放底部:司机端底部是导航栏和「确认取货」这类主按钮,
 *   盖住它们比盖住顶栏代价大得多。
 * ★ 点「稍后」也不会一直拖着:切到后台时照样自动换上 —— 提示条上写清楚这一点,
 *   免得他以为不点就永远是旧版。
 */
export function UpdateBanner() {
  const status = useUpdateStatus();
  const [applying, setApplying] = useState(false);

  if (status.kind === 'none' || status.dismissed) return null;

  return (
    <div
      role="status"
      aria-label="有新版本"
      className="fixed inset-x-3 top-[calc(env(safe-area-inset-top)+0.5rem)] z-50 mx-auto max-w-md
                 rounded-xl border border-brand-200 bg-white p-3 shadow-lg
                 dark:border-brand-800 dark:bg-slate-800"
    >
      {status.kind === 'ready' ? (
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-slate-900 dark:text-slate-100">新版本已就绪</div>
            <div className="text-xs text-slate-500">不点也行,切到后台再回来就是新版本</div>
          </div>
          <button
            onClick={dismissUpdate}
            className="shrink-0 px-2 py-1.5 text-sm text-slate-500 dark:text-slate-400"
          >
            稍后
          </button>
          <button
            onClick={() => {
              setApplying(true);
              // 成功的话页面已经重载;失败就让他还能再点
              void applyNow().catch(() => setApplying(false));
            }}
            disabled={applying}
            className="shrink-0 rounded-lg bg-brand-600 px-3 py-1.5 text-sm font-medium text-white
                       disabled:opacity-60"
          >
            {applying ? '更新中…' : '立即更新'}
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-slate-900 dark:text-slate-100">
              有新版本,需要重新安装 App
            </div>
            <div className="text-xs text-slate-500">请联系管理员获取新的安装包</div>
          </div>
          <button
            onClick={dismissUpdate}
            className="shrink-0 rounded-lg border border-slate-300 px-3 py-1.5 text-sm
                       text-slate-600 dark:border-slate-600 dark:text-slate-300"
          >
            知道了
          </button>
        </div>
      )}
    </div>
  );
}
